/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-console */
import React, { useMemo, useState } from 'react';
import {
  Button,
  Checkbox, Select, Slider, Tooltip,
} from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import './styles.css';
import { useMapContext } from '../context/map-context';
import { DEFAULT_POPUP_FIELD_KEYS } from '../context/use-map-context-hook';
import { buildPopupFieldOptions } from '../popup-fields';
import { useStore } from '../../../../store';
import { ReactComponent as Pin } from '../../../../assets/icons/pin.svg';
import { ReactComponent as Zone } from '../../../../assets/icons/zone.svg';
import { ReactComponent as Antennas } from '../../../../assets/icons/antennas.svg';
import { ReactComponent as Axxes } from '../../../../assets/icons/axxes.svg';
import { ReactComponent as Map } from '../../../../assets/icons/map.svg';
import { ReactComponent as Image } from '../../../../assets/icons/image.svg';
import { ReactComponent as SnailTrail } from '../../../../assets/icons/snailTrail.svg';
import { useLocalStorage } from '../../../providers/local-storage-provider/local-storage.context';

export const ConfigurationDrawer = (): JSX.Element => {
  const {
    setOpenConfigurationDrawer,
    configurationValues,
    updateVisibilityValue,
    updateTransparencyValue,
    setPinDigits,
    rotateMapPerAzimuth,
    resetMapRotation,
    hasAssetFilter,
    updatePopupFields,
    setAllPopupFields,
  } = useMapContext();
  const { mapReport, executedReport } = useStore();
  const [tabState, setTabState] = useState<'visibility' | 'settings'>('visibility');
  const { Option } = Select;
  const pinDigits = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  const localStorageService = useLocalStorage();
  const stored = localStorageService.get('PIN_DIGITS');
  const pinDigitsInitial: number = !Number.isNaN(Number(stored)) && Number(stored) > 0
    ? Number(stored) : 6;

  const checkBoxStyle = {
    width: '140px', height: '17px',
  };

  const popupFieldOptions = useMemo(
    () => buildPopupFieldOptions(
      executedReport.data.columns,
      mapReport.data.recordsMap,
      (executedReport.data.columns?.length ?? 0) > 0,
    ),
    [executedReport.data.columns, mapReport.data.recordsMap],
  );

  const checkedPopupFields = configurationValues.popupFields
    ?? DEFAULT_POPUP_FIELD_KEYS.filter((key) => popupFieldOptions.includes(key));

  const onPopupFieldToggle = (key: string, checked: boolean) => {
    const seed = DEFAULT_POPUP_FIELD_KEYS.filter((k) => popupFieldOptions.includes(k));
    updatePopupFields(key, checked, seed);
  };

  return (
    <div style={{
      width: '365px',
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      height: '100vh',
      padding: '32px 24px 24px 24px',
      backgroundColor: 'white',
    }}
    >

      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <span style={{ fontWeight: 700, fontSize: '16px' }}>Configuration</span>
        <CloseOutlined onClick={() => setOpenConfigurationDrawer(false)} />
      </div>
      <div style={{ overflow: 'auto' }}>
        <div style={{
          display: 'flex', flexDirection: 'row', marginBottom: '16px',
        }}
        >
          <div style={{
            borderBottom: tabState === 'visibility' ? '2px solid #3800EE' : '2px solid #0000001A',
            height: '55px',
            display: 'flex',
            width: '50%',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          >
            <span
              role="button"
              tabIndex={0}
              style={{
                fontWeight: 400, fontSize: '14px', color: '#4E4F52', cursor: 'pointer',
              }}
              onClick={() => setTabState('visibility')}
            >
              Visibility
            </span>
          </div>
          <div style={{
            borderBottom: tabState === 'settings' ? '2px solid #3800EE' : '2px solid #0000001A',
            height: '55px',
            display: 'flex',
            width: '50%',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
          }}
          >
            <span
              role="button"
              tabIndex={0}
              onClick={() => setTabState('settings')}
              style={{ fontWeight: 400, fontSize: '14px', color: '#4E4F52' }}
            >
              Settings
            </span>
          </div>
        </div>
        {tabState === 'visibility' && (
          <>
            <div style={{
              display: 'flex', flexDirection: 'column', gap: '16px', marginBottom: '40px',
            }}
            >
              <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                <div style={{ display: 'flex', flexDirection: 'row', gap: '16px' }}>
                  <div style={{
                    display: 'flex', flexDirection: 'column', gap: '8px', flex: 1,
                  }}
                  >
                    <div style={{
                      display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center',
                    }}
                    >
                      <Pin />

                      <span style={{ fontSize: '14px', fontWeight: 600 }}>PIN</span>
                    </div>
                    <div style={{
                      display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '8px',
                    }}
                    >
                      <div style={{ ...checkBoxStyle }}>
                        <Checkbox
                          className="custom-checkbox"
                          checked={configurationValues.visibility.points}
                          onChange={(e) => updateVisibilityValue('points', e.target.checked)}
                        >
                          Pins
                        </Checkbox>
                      </div>
                      {/* <div style={{ ...checkBoxStyle }}>
                    <Checkbox
                      className="custom-checkbox"
                      checked={configurationValues.visibility.clusteredPins}
                      onChange={(e) => updateVisibilityValue('clusteredPins', e.target.checked)}
                    >
                      Clustered Pins
                    </Checkbox>
                  </div> */}
                    </div>

                  </div>

                  <div style={{
                    display: 'flex', flexDirection: 'column', gap: '8px', flex: 1,
                  }}
                  >
                    <div style={{
                      display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center',
                    }}
                    >
                      <SnailTrail />
                      <span style={{ fontSize: '14px', fontWeight: 600 }}>SNAIL TRAIL</span>
                    </div>
                    <div style={{
                      display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '8px',
                    }}
                    >
                      <Tooltip
                        title={!hasAssetFilter
                          ? 'Available only when the map is filtered by a specific asset'
                          : ''}
                      >
                        <div style={{ ...checkBoxStyle }}>
                          <Checkbox
                            className="custom-checkbox"
                            checked={configurationValues.visibility.snailTrail}
                            disabled={!hasAssetFilter}
                            onChange={(e) => updateVisibilityValue('snailTrail', e.target.checked)}
                          >
                            Snail Trail
                          </Checkbox>
                        </div>
                      </Tooltip>
                    </div>

                  </div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <div style={{
                    display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center',
                  }}
                  >
                    <Zone />
                    <span style={{ fontSize: '14px', fontWeight: 600 }}>ZONE</span>
                  </div>
                  <div style={{
                    display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '8px',
                  }}
                  >
                    <div style={{ ...checkBoxStyle }}>
                      <Checkbox
                        className="custom-checkbox"
                        checked={configurationValues.visibility.zones}
                        onChange={(e) => updateVisibilityValue('zones', e.target.checked)}
                      >
                        Zone
                      </Checkbox>
                    </div>
                    <div style={{ ...checkBoxStyle }}>
                      <Checkbox
                        className="custom-checkbox"
                        checked={configurationValues.visibility.zoneLabels}
                        onChange={(e) => updateVisibilityValue('zoneLabels', e.target.checked)}
                      >
                        Zone Labels
                      </Checkbox>
                    </div>
                    {/* <div style={{ ...checkBoxStyle }}>
                  <Checkbox className="custom-checkbox" checked={configurationValues.visibility.}
                  onChange={(e) => updateVisibilityValue('zonePointsLabel', e.target.checked)}>
                    Points  Labels
                  </Checkbox>
                </div> */}

                  </div>

                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <div style={{
                    display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center',
                  }}
                  >
                    <Antennas />

                    <span style={{ fontSize: '14px', fontWeight: 600 }}>ANTENNAS</span>
                  </div>
                  <div style={{
                    display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '8px',
                  }}
                  >
                    <div style={{ ...checkBoxStyle }}>
                      <Checkbox
                        className="custom-checkbox"
                        checked={configurationValues.visibility.antennas}
                        onChange={(e) => updateVisibilityValue('antennas', e.target.checked)}
                      >
                        Antennas
                      </Checkbox>
                    </div>
                    <div style={{ ...checkBoxStyle }}>
                      <Checkbox
                        className="custom-checkbox"
                        checked={configurationValues.visibility.antennaLabels}
                        onChange={(e) => updateVisibilityValue('antennaLabels', e.target.checked)}
                      >
                        Antenna Labels
                      </Checkbox>
                    </div>
                    {/* <div style={{ ...checkBoxStyle }}>
                  <Checkbox className="custom-checkbox" checked={configurationValues.visibility.}
                  onChange={(e) => updateVisibilityValue('antenasReaderNames', e.target.checked)}>
                    Reader Names
                  </Checkbox>
                </div> */}
                    {/* <div style={{ ...checkBoxStyle }}>
                  <Checkbox className="custom-checkbox" checked={configurationValues.visibility.}
                  onChange={(e) => updateVisibilityValue('antenasReaderIPs', e.target.checked)}>
                    Reader IPs
                  </Checkbox>
                </div>
                <div style={{ ...checkBoxStyle }}>
                  <Checkbox className="custom-checkbox" checked={configurationValues.visibility.}
                  onChange={(e) => updateVisibilityValue('antenasConnections', e.target.checked)}>
                    Connections
                  </Checkbox>
                </div> */}

                  </div>

                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <div style={{
                    display: 'flex', flexDirection: 'row', gap: '4px', alignItems: 'center',
                  }}
                  >
                    <Axxes />

                    <span style={{ fontSize: '14px', fontWeight: 600 }}>XY AXES</span>
                  </div>
                  <div style={{
                    display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '8px',
                  }}
                  >
                    <div style={{ ...checkBoxStyle }}>
                      <Checkbox
                        className="custom-checkbox"
                        checked={configurationValues.visibility.xyAxes}
                        onChange={(e) => updateVisibilityValue('xyAxes', e.target.checked)}
                      >
                        XY Axes
                      </Checkbox>
                    </div>
                    <div style={{ ...checkBoxStyle }}>
                      <Checkbox
                        className="custom-checkbox"
                        checked={configurationValues.visibility.xyAxesLabels}
                        onChange={(e) => updateVisibilityValue('xyAxesLabels', e.target.checked)}
                      >
                        XY Axes Labels
                      </Checkbox>
                    </div>
                    {/* <div style={{ ...checkBoxStyle }}>
                      <Checkbox
                        className="custom-checkbox"
                        checked={configurationValues.visibility.xyGrid}
                        onChange={(e) => updateVisibilityValue('xyGrid', e.target.checked)}
                      >
                        XY Grid
                      </Checkbox>
                    </div> */}

                  </div>

                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <div style={{
                    display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center',
                  }}
                  >
                    <Axxes />

                    <span style={{ fontSize: '14px', fontWeight: 600 }}>LONLAT AXES</span>
                  </div>
                  <div style={{
                    display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '8px',
                  }}
                  >
                    <div style={{ ...checkBoxStyle }}>
                      <Checkbox className="custom-checkbox" checked={configurationValues.visibility.llAxes} onChange={(e) => updateVisibilityValue('llAxes', e.target.checked)}>
                        LL Axes
                      </Checkbox>
                    </div>
                    <div style={{ ...checkBoxStyle }}>
                      <Checkbox className="custom-checkbox" checked={configurationValues.visibility.llAxesLabels} onChange={(e) => updateVisibilityValue('llAxesLabels', e.target.checked)}>
                        LL Axes Labels
                      </Checkbox>
                    </div>
                    <div style={{ ...checkBoxStyle }}>
                      <Checkbox className="custom-checkbox" checked={configurationValues.visibility.llGrid} onChange={(e) => updateVisibilityValue('llGrid', e.target.checked)}>
                        LL Grid
                      </Checkbox>
                    </div>

                  </div>

                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <div style={{
                    display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center',
                  }}
                  >
                    <Map />

                    <span style={{ fontSize: '14px', fontWeight: 600 }}>MAP</span>
                  </div>
                  <div style={{
                    display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '8px',
                  }}
                  >
                    <div>
                      <Checkbox className="custom-checkbox" checked={configurationValues.visibility.image} onChange={(e) => updateVisibilityValue('image', e.target.checked)}>
                        Image
                      </Checkbox>
                    </div>

                  </div>

                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <div style={{
                    display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center',
                  }}
                  >
                    <Pin />

                    <span style={{ fontSize: '14px', fontWeight: 600 }}>PIN POPUP FIELDS</span>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row', gap: '16px' }}>
                    <span
                      role="button"
                      tabIndex={0}
                      onClick={() => (popupFieldOptions.length > 0
                        ? setAllPopupFields(popupFieldOptions) : undefined)}
                      style={{
                        fontSize: '12px',
                        color: popupFieldOptions.length === 0 ? '#B0B0B0' : '#3800EE',
                        cursor: popupFieldOptions.length === 0 ? 'not-allowed' : 'pointer',
                      }}
                    >
                      Select All
                    </span>
                    <span
                      role="button"
                      tabIndex={0}
                      onClick={() => (popupFieldOptions.length > 0
                        ? setAllPopupFields([]) : undefined)}
                      style={{
                        fontSize: '12px',
                        color: popupFieldOptions.length === 0 ? '#B0B0B0' : '#3800EE',
                        cursor: popupFieldOptions.length === 0 ? 'not-allowed' : 'pointer',
                      }}
                    >
                      Deselect All
                    </span>
                  </div>
                  <div style={{
                    display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '8px',
                  }}
                  >
                    {popupFieldOptions.length === 0 ? (
                      <span style={{ fontSize: '12px', color: '#81848C' }}>
                        No fields available
                      </span>
                    ) : popupFieldOptions.map((key) => (
                      <div key={key} style={{ ...checkBoxStyle }}>
                        <Checkbox
                          className="custom-checkbox"
                          checked={checkedPopupFields.includes(key)}
                          onChange={(e) => onPopupFieldToggle(key, e.target.checked)}
                        >
                          <span
                            title={key}
                            style={{
                              display: 'inline-block',
                              maxWidth: '108px',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              verticalAlign: 'middle',
                            }}
                          >
                            {key}
                          </span>
                        </Checkbox>
                      </div>
                    ))}
                  </div>

                </div>
              </div>

            </div>
            <div style={{
              display: 'flex', flexDirection: 'column', gap: '16px', marginBottom: '40px',
            }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Image />

                <span style={{ fontWeight: 600, fontSize: '16px', color: '#4E4F52' }}>Image position</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'row', gap: '16px' }}>
                <Button style={configurationValues.orientation === 'nup' ? { backgroundColor: '#3800EE', color: 'white' } : {}} onClick={resetMapRotation}>
                  n up
                </Button>
                <Button style={configurationValues.orientation === 'yup' ? { backgroundColor: '#3800EE', color: 'white' } : {}} onClick={rotateMapPerAzimuth}>
                  y up
                </Button>
              </div>

            </div>

            <div style={{
              display: 'flex', flexDirection: 'column', gap: '16px',
            }}
            >
              <span style={{ fontWeight: 600, fontSize: '16px', color: '#4E4F52' }}>Transparency</span>
              <div style={{
                display: 'flex', flexDirection: 'column', width: '95%', gap: '16px',
              }}
              >
                <div>
                  <div style={{
                    gap: '4px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                  >
                    <Image />
                    <span>Image</span>
                  </div>
                  <Slider
                    className="custom-slider"
                    min={0}
                    max={1}
                    step={0.05}
                    value={configurationValues.transparency.image}
                    onChange={(e) => updateTransparencyValue('image', e)}
                  />
                </div>
                <div>
                  <div style={{
                    gap: '4px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                  >
                    <Pin />

                    <span>Points</span>
                  </div>
                  <Slider
                    min={0}
                    max={1}
                    step={0.05}
                    className="custom-slider"
                    value={configurationValues.transparency.points}
                    onChange={(e) => updateTransparencyValue('points', e)}
                  />
                </div>
                <div>
                  <div style={{
                    gap: '4px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                  >
                    <Zone />

                    <span>Zones</span>
                  </div>
                  <Slider
                    min={0}
                    max={1}
                    step={0.05}
                    className="custom-slider"
                    value={configurationValues.transparency.zones}
                    onChange={(e) => updateTransparencyValue('zones', e)}
                  />
                </div>
                {/* <div>
              <span>XY Axis</span>
              <Slider className="custom-slider"
               defaultValue={configurationValues.transparency.xyaxis}
               onChange={(e) => updateTransparencyValue('xyaxis', e)} />
            </div>
            <div>
              <span>XY Grid</span>
              <Slider className="custom-slider"
               defaultValue={configurationValues.transparency.xygrid}
               onChange={(e) => updateTransparencyValue('xygrid', e)} />
            </div>
            <div>
              <span>LL Axis</span>
              <Slider className="custom-slider"
               defaultValue={configurationValues.transparency.llgrid}
               onChange={(e) => updateTransparencyValue('llgrid', e)} />
            </div> */}
              </div>
            </div>
          </>
        )}
        {tabState === 'settings' && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <span style={{ fontWeight: 400 }}>
              Set the number of EPC digits to display on pins
            </span>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontSize: '14px', fontWeight: 400, color: '#81848C' }}>Number of digits</span>
              <Select
                style={{ width: '165px' }}
                defaultValue={pinDigitsInitial}
                onChange={(num) => {
                  setPinDigits(num);
                  localStorageService.set('PIN_DIGITS', num);
                }}
              >
                {
                  pinDigits.map((option, i) => (
                    <Option
                      value={option}
                      key={`${option + i}`}
                    >
                      {option}
                    </Option>
                  ))
                }

              </Select>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
